import type { FC } from 'react'
import cn from 'classnames'
import type { FilterBlockProps } from '.'
import s from './filter-block.module.css'

const FilterBlock: FC<FilterBlockProps> = ({ title = '', children, vertical = false }) => {
  return (
    <div className={cn(s.root, vertical && s.vertical)}>
      {title && <h2 className={s.title}>{title}</h2>}
      {children}
    </div>
  )
}

export default FilterBlock
